const makingOf = {
    portugues: {
      title: 'Making Of',
      subTitle: 'Conheça as mais belas gatas do Bella da Semana. Confira abaixo as últimas modelos:',
      placeHolderSelect: 'Filtrar por nome',
      SeeAllModels: 'Veja todas modelos:',
      seeAllMakingOf: 'Acesse todos os Making Of',
      makingOfTitle: 'Making Of',
      seeAllMakingOfPrefix: 'Acesse todos os',
      seeAllMakingOfHighlight: 'Making Of',
      labelPagination: 'de',
      shootModel: 'Veja o making of',
      featuredModels: 'Modelos em destaque:',
      lastModels: 'Últimas Modelos',
      models: 'Modelos',
      categories: 'CATEGORIAS',
      nextPage: 'PRÓXIMA PÁGINA',
      prevPage: 'PÁGINA ANTERIOR'
    },
    ingles: {
      title: 'Making Of',
      subTitle: 'Meet the most beautiful Bella Club babes. Check out the latest models below:',
      placeHolderSelect: 'Filter by name',
      SeeAllModels: 'See all models:',
      seeAllMakingOf: 'Access all Making Of',
      makingOfTitle: 'Making Of',
      seeAllMakingOfPrefix: 'Access all',
      seeAllMakingOfHighlight: 'Making Of',
      labelPagination: 'of',
      shootModel: 'See the making of',
      featuredModels: 'Featured Models:',
      lastModels: 'Last Models',
      models: 'Models',
      categories: 'CATEGORIES',
      nextPage: 'NEXT PAGE',
      prevPage: 'PREVIOUS PAGE'
    }
  }
  
  export default makingOf
  